import {Matcher} from '@/lib/axiosAddTransforms'

const taxrefundSerializer = (data) => {
  return {
    ...data,
  }
}

const matchers: Matcher[] = [
    {
      test: /^\/taxrefund\/?$/,
      method: 'get',
      transform: {
        request: (payload) => {
          const {bizId} = payload.data
          payload.url = `/bizs/${bizId}/taxrefund/`
  
          delete payload.data.bizId
  
          return payload
        },
        response: taxrefundSerializer
      },
    },
    {
      test: /^\/taxrefund\/?$/,
      method: 'post',
      transform: {
        request: (payload) => {
          const {bizId} = payload.data
          payload.url = `/bizs/${bizId}/taxrefund/`
  
          delete payload.data.bizIds
  
          return payload
        },
        response: (data) => data
      },
    },
    {
      test: /^\/surveyKey\/?$/,
      method: 'get',
      transform: {
        request: (payload) => {
          const {bizId, baseYear} = payload.data
          payload.url = `/survey/${bizId}/session_key`
          payload.params = {base_year: baseYear}
  
          return payload
        },
        response: (data) => data
      },
    },
  ]
  
  export default matchers
  